import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-json-viewer',
  templateUrl: './json-viewer.component.html',
  styleUrls: ['./json-viewer.component.css']
})
export class JsonViewerComponent {
  @Input() jsonData: any;

  // 確保這是物件
  isObject(value: any): boolean {
    return typeof value === 'object' && value !== null;
  }

  getKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : []; // 如果 obj 為 null 或 undefined，回傳空陣列
  }
  
  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  isString(value: any): boolean {
    return typeof value === 'string';
  }

  isNumber(value: any): boolean {
    return typeof value === 'number';
  }

  isBoolean(value: any): boolean {
    return typeof value === 'boolean';
  }

  isNull(value: any): boolean {
    return value === null;
  }
}
